var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.editData
    ? _c(
        "form",
        {
          class: { "sticky-actions": _vm.stickyActions && !_vm.iniDisabled },
          attrs: { onSubmit: "return false;" },
          on: {
            keydown: function ($event) {
              return _vm.$emit("onKeydown", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "section blank m0 form" },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "overlay" },
                    [
                      _c("loader", {
                        attrs: {
                          text: _vm.loadingLabel
                            ? _vm.loadingLabel
                            : _vm.$t("saving"),
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideMessages
                ? _c("hasError", { attrs: { v: _vm.v, e: _vm.errorLogInfo } })
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideChanges && _vm.isChanged && !_vm.iniDisabled
                ? _c("article", { staticClass: "notification is-warning" }, [
                    _c("span", [
                      _vm._v("The data has been changed, please refresh."),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _c("div", { staticClass: "action-wrapper" }, [
                !_vm.iniDisabled && !_vm.hideActions
                  ? _c("div", { staticClass: "action v-center mt15-xs" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button is-success",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$emit("onSave")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.btnLabel ? _vm.btnLabel : _vm.$t("save")
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.hideCancel && !_vm.isLoading
                        ? _c(
                            "a",
                            {
                              staticClass: "button is-cancel",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return ((payload) =>
                                    _vm.$emit("onCancel", payload)).apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.cancelLabel
                                      ? _vm.cancelLabel
                                      : _vm.$t("cancel")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !!this.$slots.actionRight
                        ? _c(
                            "div",
                            { staticClass: "ml-auto" },
                            [_vm._t("actionRight")],
                            2
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }